/**
 * 再入荷リクエスト → App Proxy POST /apps/mypage/restock
 */

(function () {
  'use strict';

  function cfg() {
    return window.GanymedeRestock || {};
  }

  function resolveProxyUrl(url) {
    if (!url || typeof url !== 'string') {
      return url;
    }
    var u = url.trim();
    if (/^https?:\/\//i.test(u)) {
      return u;
    }
    var origin = window.location.origin || '';
    return origin && u.charAt(0) === '/' ? origin + u : u;
  }

  function parseResponseJson(text) {
    var t = String(text || '').replace(/^\uFEFF/, '').trim();
    if (!t) {
      return { __parseError: 'empty_body' };
    }
    try {
      return JSON.parse(t);
    } catch (e1) {
      var start = t.indexOf('{');
      var end = t.lastIndexOf('}');
      if (start !== -1 && end > start) {
        try {
          return JSON.parse(t.slice(start, end + 1));
        } catch (e2) {
          return { __parseError: 'invalid_json' };
        }
      }
      return { __parseError: 'invalid_json' };
    }
  }

  function detectDevice() {
    var ua = navigator.userAgent || '';
    if (/Mobile|Android|iPhone|iPod/i.test(ua)) {
      return 'mobile';
    }
    return 'desktop';
  }

  /* ===== リクエスト済みの見た目 =====
     ⚠️ バリエーション単位で持つ。商品単位にすると、別の種類を選んでいるのに
        「リクエスト済み」のままになる。ZETA（zeta-restock.js）と同じ作り。 */
  var requested = null;

  function requestedSet() {
    if (requested) {
      return requested;
    }
    requested = {};
    var list = cfg().requestedVariantIds || [];
    for (var i = 0; i < list.length; i++) {
      requested[String(list[i])] = true;
    }
    return requested;
  }

  function removeButtonFor(btn) {
    var wrap = btn.closest('.ganymede-restock');
    return wrap ? wrap.querySelector('[data-restock-remove]') : null;
  }

  function applyButtonState(btn) {
    var id = String(btn.getAttribute('data-variant-id') || '');
    var done = !!requestedSet()[id];
    var strings = cfg().strings || {};
    var label = done ? strings.requested : strings.request;

    if (label) {
      btn.textContent = label;
      btn.setAttribute('aria-label', label);
    }
    btn.classList.toggle('is-requested', done);
    if (done) {
      btn.setAttribute('data-restock-done', 'true');
      btn.disabled = true;
    } else {
      btn.removeAttribute('data-restock-done');
      btn.disabled = false;
    }

    /* 「リクエストを削除」は、済みのときだけ出す */
    var rm = removeButtonFor(btn);
    if (rm) {
      rm.setAttribute('data-variant-id', id);
      rm.hidden = !done;
      if (done) {
        rm.disabled = false;
      }
    }
  }

  function applyAll() {
    document.querySelectorAll('[data-restock-button]').forEach(applyButtonState);
  }

  function syncVariantId(variantId) {
    if (!variantId) {
      return;
    }
    document.querySelectorAll('[data-restock-button]').forEach(function (btn) {
      btn.setAttribute('data-variant-id', String(variantId));
      applyButtonState(btn);
    });
  }

  function showFeedback(btn, message, isError) {
    var wrap = btn.closest('.ganymede-restock');
    if (!wrap) {
      return;
    }
    var el = wrap.querySelector('[data-restock-feedback]');
    if (!el) {
      return;
    }
    el.textContent = message;
    el.hidden = false;
    el.classList.toggle('ganymede-restock__feedback--error', !!isError);
    clearTimeout(el._hideTimer);
    el._hideTimer = setTimeout(function () {
      el.hidden = true;
    }, 8000);
  }

  async function onRestockClick(ev) {
    var btn = ev.target.closest && ev.target.closest('[data-restock-button]');
    if (!btn) {
      return;
    }
    ev.preventDefault();

    var c = cfg();
    var strings = c.strings || {};

    if (!c.apiUrl) {
      return;
    }
    if (!c.customerLoggedIn) {
      window.alert(strings.loginRequired || 'Login required');
      return;
    }

    var productId = parseInt(btn.getAttribute('data-product-id') || '0', 10);
    var handle = (btn.getAttribute('data-product-handle') || '').trim();
    var variantId = parseInt(btn.getAttribute('data-variant-id') || '0', 10);
    if (productId <= 0 || !handle || variantId <= 0) {
      window.alert(strings.badRequest || 'Invalid product');
      return;
    }

    if (btn.disabled) {
      return;
    }
    btn.disabled = true;
    var url = resolveProxyUrl(c.apiUrl);
    var reqBody = {
      action: 'restock_add',
      product_id: productId,
      product_handle: handle,
      variant_id: variantId,
      device: detectDevice(),
    };
    try {
      var res = await fetch(url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(reqBody),
      });
      var text = await res.text();
      var data = parseResponseJson(text);

      if (window.GanymedeDebug && window.GanymedeDebug.logApi) {
        window.GanymedeDebug.logApi('restock_add', url, res, reqBody, text, data);
      }

      if (data.profile_incomplete) {
        window.location.href = c.mypageUrl || '/pages/mycollection';
        return;
      }

      if (!res.ok || data.__parseError || !data.ok) {
        throw new Error(data.error || data.__parseError || 'HTTP ' + res.status);
      }

      requestedSet()[String(variantId)] = true;
      var msg = data.duplicate ? strings.duplicate || strings.submitted : strings.submitted;
      showFeedback(btn, msg || 'OK', false);
    } catch (err) {
      showFeedback(btn, (strings.error || 'Error') + ': ' + err.message, true);
    } finally {
      btn.disabled = false;
      applyButtonState(btn);
    }
  }

  /* 「リクエストを削除」。マイコレクションの削除ボタンと同じ restock_remove を投げる */
  async function onRestockRemoveClick(ev) {
    var rm = ev.target.closest && ev.target.closest('[data-restock-remove]');
    if (!rm) {
      return;
    }
    ev.preventDefault();

    var c = cfg();
    var strings = c.strings || {};
    if (!c.apiUrl) {
      return;
    }
    /* 追加側・ZETA の削除側と同じく、未ログインはここで止める。
       セッション切れのときに素の API エラーを見せないため */
    if (!c.customerLoggedIn) {
      window.alert(strings.loginRequired || 'Login required');
      return;
    }

    var wrap = rm.closest('.ganymede-restock');
    var btn = wrap && wrap.querySelector('[data-restock-button]');
    var variantId = parseInt(rm.getAttribute('data-variant-id') || '0', 10);
    if (variantId <= 0 || rm.disabled) {
      return;
    }

    rm.disabled = true;
    var url = resolveProxyUrl(c.apiUrl);
    var reqBody = { action: 'restock_remove', variant_id: variantId };
    try {
      var res = await fetch(url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(reqBody),
      });
      var text = await res.text();
      var data = parseResponseJson(text);

      if (window.GanymedeDebug && window.GanymedeDebug.logApi) {
        window.GanymedeDebug.logApi('restock_remove', url, res, reqBody, text, data);
      }

      if (!res.ok || data.__parseError || !data.ok) {
        throw new Error(data.error || data.__parseError || 'HTTP ' + res.status);
      }

      delete requestedSet()[String(variantId)];
      if (btn) {
        applyButtonState(btn);
        showFeedback(btn, strings.removed || 'OK', false);
      }
    } catch (err) {
      rm.disabled = false;
      if (btn) {
        showFeedback(btn, (strings.removeError || strings.error || 'Error') + ': ' + err.message, true);
      }
    }
  }

  document.addEventListener('click', onRestockClick, true);
  document.addEventListener('click', onRestockRemoveClick, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyAll);
  } else {
    applyAll();
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var variant = event.data && event.data.variant;
      if (variant && variant.id) {
        syncVariantId(variant.id);
      }
    });
  }

  document.addEventListener('change', function (ev) {
    var input = ev.target;
    if (input && input.classList && input.classList.contains('product-variant-id')) {
      syncVariantId(input.value);
    }
  });
})();
